import { renderModal } from 'helpers/modal-render';
import Icons from 'assets/icons';

interface ActionMenuItem {
  label: string;
  icon: React.ReactNode;
  isDelete?: boolean;
  onClick: () => void;
}

interface GetActionMenuItemsArgs {
  handleDelete: (reportId: string | number) => void;
  reportId: string | number;
  reportName?: string;
}

export const getActionMenuItems = ({
  handleDelete,
  reportId,
  reportName,
}: GetActionMenuItemsArgs): ActionMenuItem[] => [
  {
    label: 'Delete report',
    icon: <Icons.Delete customClass="text-critical-500 mr-2" />,
    isDelete: true,
    onClick: () =>
      renderModal({
        headerText: `Are you sure you want to delete the ${reportName} report?`,
        onConfirmCallback: () => {
          handleDelete(reportId);
        },
        onConfirmButtonLabel: 'Delete report',
        text: `Deleting the ${reportName} report will remove it from the list of available reports and unlink it from associated products.`,
        'data-testid': 'delete-report-modal',
      }),
  },
];
